import { useBreakpoint } from "ui/hooks/use-media-query";

/**
 * True below lg, where the mobile shell (tab bar, sheets) runs: phones and
 * tablets. False on desktop and before the breakpoint resolves after mount.
 */
export const useCompactShell = () => {
  const breakpoint = useBreakpoint();
  return breakpoint === "phone" || breakpoint === "tablet";
};
